export default "__VITE_ASSET__9fccfb3f__"